import type { JSX } from 'react'
import type { ToastActionProps } from './types'
import { ToastActionButton } from './ToastActionButton'

/**
 * Several toast shortcuts as a full-width row of equal, labelled halves.
 * Use through withToastActions, which gives the toast the classNames the row needs.
 */
export const ToastActions = ({ actions }: {
  actions: ToastActionProps[]
}): JSX.Element | null => {
  const available = actions.filter((action) => !!action.documentId)

  if (!available.length) {
    return null
  }

  return (
    <div className='flex basis-full divide-x divide-current/15 border-t border-current/15 pt-2 mt-1'>
      {available.map((action) => (
        <ToastActionButton key={`${action.withView}-${action.documentId}`} {...action} />
      ))}
    </div>
  )
}
